const defaultStatCardStyle = {
  container: {
    display: 'flex',
    flexDir: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '15px',
    marginBottom: '2vh',
  },
  cardContainer: {
    width: '14vw',
    height: '5vw',
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dateCardContainer: {
    width: '8vw',
    height: '2vw',
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardText: {
    fontFamily: 'Poppins',
    fontSize: '14px',
  },
  cardNumber: {
    color: '#000',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: 'Bold',
  },
};

export default defaultStatCardStyle;
